export default __webpack_public_path__ + "static/media/fad-filter-rez-lowpass.be615c9e.svg";